import { Skeleton, SkeletonProps } from '@mui/material';

type SkeletonWrapperProps = {
  children: React.ReactNode;
  isLoading: boolean;
} & SkeletonProps;

const SkeletonWrapper = ({
  children,
  isLoading,
  ...rest
}: SkeletonWrapperProps) => {
  return isLoading ? <Skeleton {...rest}>{children}</Skeleton> : children;
};

export default SkeletonWrapper;
